<template>
  <div id="wrap">
    <!-- title -->
    <div class="title">B端行业解决方案</div>
    <div class="text">同城帮秉承让二手买卖不再难做的商业原则，打通B端上下游产业链、供应链，为B端合作伙伴提供创新产品技术支持，互惠互赢。</div>

    <!-- 内容区 -->
    <ul class="content">
      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p5.ssl.qhimg.com/t01ab94db14d2888934.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">渠道商解决方案</div>
          <!-- text -->
          <div class="content-bottom-text">作为苏宁易购的战略合作伙伴，同城帮有能力在自己的平台之外，为您提供更多的施展空间。</div>
        </div>
      </li>

      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p3.ssl.qhimg.com/t0190156002f7fab936.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">运营商解决方案</div>
          <!-- text -->
          <div class="content-bottom-text">同城帮与中国移动在旧机信用回收等业务上的深度合作，可以为您争取更多的运营商福利。</div>
        </div>
      </li>

      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p4.ssl.qhimg.com/t0127ac5cd813e29508.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">品牌商解决方案</div>
          <!-- text -->
          <div
            class="content-bottom-text"
          >同城帮在以旧换新、一站式换新等业务上，与华为、荣耀、Apple、小米、OPPO、vivo等品牌达成过默契的合作，为您提供更主流的品牌支持。</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#wrap {
  .title {
    color: #000000;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .text {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 50px;
  }
  //   展示区
  .content {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 50px;
    li {
      width: 306px;
      height: 474px;
      box-shadow: 0px 2px 15px 0px rgba(0, 57, 44, 0.13);
      .content-top {
        img {
          height: 236px;
          width: 100%;
        }
      }
      .content-bottom {
        // padding: 25px 30px 35px 30px;
        padding: 0 30px;
        box-sizing: border-box;
        .content-bottom-title {
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          color: #000000;
          margin-bottom: 30px;
          margin-top: 25px;
        }
        .content-bottom-text {
          font-size: 16px;
          color: #666666;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
